export const defaultState = () => ({
	taxonomies: {},
	config: {
		hasMailPoet: false,
		isWooActive: null,
		isWooConnected: null,
		isEddActive: null,
		isEddConnected: null,
		eddVersion: {},
		mailPoetLists: [],
		mailPoetFields: [],
	},
	posts: [],
	memberpress: {
		isActive: false,
		isCoursesActive: false,
		checkoutTemplateEnabled: false,
		wpFooterDisabled: false,
		groups: [],
		memberships: [],
		courses: [],
		lessons: [],
		quizzes: [],
	},
	postTypes: [],
	campaigns: [],
	search: '',
	wooKey: {
		id: '',
		description: '',
		truncated: '',
		editUrl: '',
	},
	edd: {
		key: '',
		token: '',
		editUrl: '',
		description: '',
	},
	error: false,
});
const state = defaultState();

export default state;
